module.exports = __webpack_public_path__ + "img/muban0249.470bffb0.png";